import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import TripBookingGuidelineCreatePage from './trip-booking-guideline-create'
import TripBookingGuidelineListPage from './trip-booking-guideline-list'
import TripBookingGuidelineUpdatePage from './trip-booking-guideline-update'

const tripBookingGuidelineRoutes: Route[] = [
  {
    path: Paths.TRIP_BOOKING_GUIDELINE_LIST_PAGE,
    element: <TripBookingGuidelineListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_BOOKING_GUIDELINE_CREATE_PAGE,
    element: <TripBookingGuidelineCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_BOOKING_GUIDELINE_UPDATE_PAGE,
    element: <TripBookingGuidelineUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default tripBookingGuidelineRoutes
